export default function() {
   return {
      trades: [],
      loaded: false,
   };
}
